import { forwardRef, useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

const formatTR = (n) => {
  if (n === "" || n === null || n === undefined) return "";
  const num = Number(n);
  if (isNaN(num)) return "";
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

const parseTR = (text) => {
  if (!text) return 0;
  const cleaned = String(text).replace(/\./g, "").replace(",", ".");
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
};

/**
 * MoneyInput — Türkçe format 1.000.000,00
 * Kullanıcı düzenlerken raw metni tutar; focus kaybedince (blur) formatlar.
 */
const MoneyInput = forwardRef(({ value, onChange, ...props }, ref) => {
  const [focused, setFocused] = useState(false);
  const [raw, setRaw] = useState("");

  // Dışarıdan value değişince ve focus yoksa raw'ı senkronla (formatlı)
  useEffect(() => {
    if (!focused) {
      setRaw(value === 0 || value === "0" || value === "" || value === null || value === undefined
        ? ""
        : formatTR(value));
    }
    // eslint-disable-next-line
  }, [value]);

  const handleChange = (e) => {
    const text = e.target.value;
    // Sadece rakam, nokta, virgül
    const filtered = text.replace(/[^\d.,]/g, "");
    setRaw(filtered);
    const num = parseTR(filtered);
    onChange?.(num);
  };

  const handleFocus = () => {
    setFocused(true);
    // Odaklandığında düz yaz — kullanıcı görsel olarak formatı bozmadan yazabilir
    // (raw zaten formatlı görünür; kullanıcı isterse silip yeniden yazar)
  };

  const handleBlur = () => {
    setFocused(false);
    // Blur'da formatlı görünüme dön
    const num = parseTR(raw);
    setRaw(num ? formatTR(num) : "");
  };

  return (
    <Input
      ref={ref}
      type="text"
      inputMode="decimal"
      value={raw}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...props}
    />
  );
});
MoneyInput.displayName = "MoneyInput";
export default MoneyInput;
export { formatTR, parseTR };
